"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.supplementWebVitals = void 0;
/* eslint-disable no-restricted-globals */
const graphene_1 = __importDefault(require("@snapchat/graphene"));
function supplementWebVitals(pageId, metricsPrefix) {
    // performance.timing metrics are only available after page load
    if (document.readyState === "complete") {
        void supplementPerformanceMetrics(pageId, metricsPrefix);
    }
    else {
        window.addEventListener("load", () => {
            void supplementPerformanceMetrics(pageId, metricsPrefix);
        });
    }
}
exports.supplementWebVitals = supplementWebVitals;
function supplementPerformanceMetrics(pageName, metricsPrefix) {
    /* istanbul ignore next -- will never hit this */
    if (typeof window === "undefined") {
        return;
    }
    setTimeout(() => {
        const { navigationStart, loadEventStart, loadEventEnd, requestStart, responseStart, responseEnd, domInteractive, domContentLoadedEventStart, domContentLoadedEventEnd, } = window.performance.timing;
        const missing = (event) => {
            graphene_1.default.increment({ metricsName: `missingNavigationTiming.${event}` });
        };
        const reportNavTimer = (name, millis) => {
            const pagePrefix = `${metricsPrefix}.byPage.${pageName}`;
            const byNavigation = `${pagePrefix}.byNavigation.${name}`;
            graphene_1.default.addTimer({ metricsName: byNavigation, milliSec: millis });
        };
        if (!loadEventStart) {
            missing("loadEventStart");
        }
        if (!loadEventEnd) {
            missing("loadEventEnd");
        }
        if (!navigationStart) {
            missing("navigationStart");
        }
        if (!requestStart) {
            missing("requestStart");
        }
        if (!responseStart) {
            missing("responseStart");
        }
        if (!responseEnd) {
            missing("responseEnd");
        }
        if (!domInteractive) {
            missing("domInteractive");
        }
        if (!domContentLoadedEventStart) {
            missing("domContentLoadedEventStart");
        }
        if (!domContentLoadedEventEnd) {
            missing("domContentLoadedEventEnd");
        }
        // These metrics supplement TTFB (time to first byte) and are an indication
        // of network performance
        if (requestStart && navigationStart) {
            reportNavTimer("navigationStartToRequestStart", requestStart - navigationStart);
        }
        if (requestStart && responseStart) {
            reportNavTimer("requestStartToResponseStart", responseStart - requestStart);
        }
        if (responseStart && responseEnd) {
            reportNavTimer("responseStartToResponseEnd", responseEnd - responseStart);
        }
        if (navigationStart && responseEnd) {
            reportNavTimer("navigationStartToResponseEnd", responseEnd - navigationStart);
        }
        // These metrics supplement FCP and LCP metrics
        if (domInteractive && responseStart) {
            reportNavTimer("responseStartToInteractive", domInteractive - responseStart);
        }
        if (domInteractive && navigationStart) {
            reportNavTimer("navigationStartToInteractive", domInteractive - navigationStart);
        }
        if (domContentLoadedEventEnd && domContentLoadedEventStart) {
            reportNavTimer("domContentLoadedEventStartToEnd", domContentLoadedEventEnd - domContentLoadedEventStart);
        }
        if (loadEventStart && loadEventEnd) {
            reportNavTimer("loadEventStartToEnd", loadEventEnd - loadEventStart);
        }
        void graphene_1.default.flush();
    }, 0);
}
//# sourceMappingURL=performanceTiming.js.map